export enum AUTH_CLAIMS {
  CAN_MANAGE_TEXTS = "canManageTexts",
  CAN_MANAGE_TRAVELS = "canManageTravels",
  CAN_MANAGE_ADMINS = "canManageAdmins",
}
